import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { API_MAP } from 'app/core/helpers/api.map';
import { map } from 'rxjs';
import { ContentPagesService } from './content-pages.service';
import { removeQueryParams } from 'app/shared/components/select/helper-functions';

export const ContentPagesResolver: ResolveFn<boolean> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  var contentService = inject(ContentPagesService);
  contentService.controller = API_MAP.contentPages + removeQueryParams(state.url).substring(1);
  return contentService.get().pipe(map(() => true));
};
